import React, { Fragment } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import { Look3DIcon, LookAugmentRealityIcon } from "../../common/icons";
import { LOOK_FEATURE_CONTENT } from "../../look/core/constants";
import COLOR_THEMES from "../../../colorThemes";
import config from "../../sqft/components/canvas/store/sqftConfig";
import {
  changeSqftFeaturesPopup,
  setAPIErrorMessage,
  setSqftCabinetsGlb,
  setSQFTViewMode
} from "../../../actions/sqftFunctions";
import { setAbortController, setSQFTAr3dPopup } from "../../../actions/sqftMenuFunctions";
import { SQFT_VIEW_MODE } from "../../sqft/constants";
import { setCabinetGLBFromCabinetsSet } from "../../sqft/helpers/sqft3dArHelper";
import {setMultiLoader} from "../../../actions/actionFunctions";

export const SqftFeaturesPopup3dButtons = (props) => {
  const { changeSqftFeaturesPopup, isMobile, setSQFTViewMode } = props;

  const threeDButtonClick = async () => {
    changeSqftFeaturesPopup({
      opened: false,
      sqftPassedData: null
    });
    // if (SQFTViewMode === SQFT_VIEW_MODE.threeDMode) {
    //   setMultiLoader({activeStep: 0, visible: true, finished: false});
    // }
    setSQFTViewMode(SQFT_VIEW_MODE.threeDMode);
    await setCabinetGLBFromCabinetsSet().then(r => void r);
    // setSQFTAr3dPopup({isOpened: true, contentType: SQFT_AR3D_POPUP_CONTENT_TYPE.threeD})
    // await setCabinetGLBFromCabinetsSet().then(r => void r);
  }

  const arButtonClick = async () => {
    changeSqftFeaturesPopup({
      opened: false,
      sqftPassedData: null
    });
    // if (SQFTViewMode === SQFT_VIEW_MODE.augmentedReality) {
    //   setMultiLoader({activeStep: 0, visible: true, finished: false});
    // }
    setSQFTViewMode(SQFT_VIEW_MODE.augmentedReality);
    await setCabinetGLBFromCabinetsSet().then(r => void r);
    // setSQFTAr3dPopup({isOpened: true, contentType: SQFT_AR3D_POPUP_CONTENT_TYPE.ar})
    // await setCabinetGLBFromCabinetsSet().then(r => void r);
  }

  const threeDButtonID = isMobile ? 'sqft.popup.button.3dButtonMobile' : 'sqft.popup.button.3dButton';
  const augButtonID = isMobile ? 'sqft.popup.button.augButtonMobile' : 'sqft.popup.button.augButton';

  return (
    <Fragment>
      <Button className={"ui-button2 ui-button2--primary-border"}
              startIcon={(

                <SvgIcon>
                  <Look3DIcon color={ COLOR_THEMES[config.activeTheme].primary } />
                </SvgIcon>
              )}
              onClick={() => threeDButtonClick(LOOK_FEATURE_CONTENT.threeD)}>
          <FormattedMessage id={threeDButtonID}/>
      </Button>
      <Button className={"ui-button2 ui-button2--primary-border"}
              disabled={false}
              startIcon={(
                <SvgIcon>
                  <LookAugmentRealityIcon color={ COLOR_THEMES[config.activeTheme].primary } />
                </SvgIcon>
              )}
              onClick={() => arButtonClick(LOOK_FEATURE_CONTENT.aug)}>
              <FormattedMessage id={augButtonID}/>
      </Button>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
    abortRequestController: store.sqftState.abortRequestController,
    cabinetsGlb: store.sqftState.cabinetsGlb,
    SQFTViewMode: store.sqftState.SQFTViewMode,
  };
};
const mapDispatchToProps = {
  setSqftCabinetsGlb,
  setSQFTAr3dPopup,
  changeSqftFeaturesPopup,
  setAPIErrorMessage,
  setAbortController,
  setSQFTViewMode,
  setMultiLoader,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopup3dButtons)
)
